import { Map } from 'immutable';

import * as types from '../actions/action_types';
import { StoreRecord } from '../records/store_records.js';
import { setValue, setError, setPending } from './helpers.js';

const initialState = Map({
    graphData: new StoreRecord(),
});

export default (state = initialState, action) => {
  switch(action.type) {
    case types.ADBLOCK_PENDING:
      return setPending(state, ['graphData']);

    case types.ADBLOCK_LOADED:
      return setValue(state, ['graphData'], action.data);

    case types.ADBLOCK_ERROR:
      return setError(state, ['graphData'], action.errorMessage);
  }
  return state;
};
